import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { DEFAULT_EVIDENCIA_STATUS_OPTIONS } from "@/constants";

/**
 * Hook to fetch evidencia status options from the 'estatus_evidencia' catalog.
 * Falls back to DEFAULT_EVIDENCIA_STATUS_OPTIONS if empty or failed.
 */
export function useEvidenciaStatusOptions() {
  const { data, isLoading } = useQuery({
    queryKey: ["catalogs", "estatus_evidencia"],
    queryFn: async () => (await api.get("/catalogs", { params: { type: "estatus_evidencia" } })).data,
    staleTime: 30_000,
  });
  const items = (data || []).map((c) => c.name);
  return {
    options: items.length > 0 ? items : DEFAULT_EVIDENCIA_STATUS_OPTIONS,
    isLoading,
  };
}
